import React, { Component } from "react";
import LocateUsCity from "./LocateUsCity";
import {
  mapKey,
  imagePrefix,
  HIStoresAPI,
} from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";
import "../../../../public/styles/HomeInteriors/LocateUs/LocateUsMain.scss";
import Geocode from "react-geocode";

export default class LocateusMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citySelected: 0,
      storeData: [],
      pincode: "",
      regions: [],
    };
  }

  onCitySelect = e => {
    this.setState(
      {
        citySelected: e,
        pincode: e.pincode,
        regions: e.regions,
      },
      () => {
        Geocode.setApiKey(mapKey);
        Geocode.fromAddress(this.state.pincode).then(
          response => {
            const { lat, lng } = response.results[0].geometry.location;
            this.getStoreData(lat, lng, e.city);
          },
          error => {}
        );
      }
    );
  };

  getStoreData(lat, lng, city) {
    const data = {
      params: {
        latitude: lat,
        longitude: lng,
        cityname: city,
      },
    };
    apiManager
      .get(`${HIStoresAPI}`, data)
      .then(response => {
        this.setState({
          storeData: response.data.data,
          allstoreData: response.data,
          isLoading: false,
          isOpen: false,
          isError: false,
          filteredSingleStore: null,
        });
      })
      .catch(error => {
        this.setState({
          storeData: null,
          isLoading: false,
          searchStoreType: "city",
          isError: true,
          filteredSingleStore: null,
        });
      });
  }

  selectStore(data, storeMaster, citySelected, regions) {
    console.log(`ONE${citySelected}`)
    this.props.onStoreSelect(data, storeMaster, citySelected, regions);
  }

  render() {
    return (
      <div className="HI-LocateStoreContainer">
        <LocateUsCity changeCity={this.onCitySelect.bind(this)} />
        <div className="stores-container">
          <div className="stores-wrapper">
            {this.state.storeData &&
              this.state.storeData.map((store, key) => (
                <div className="card-container">
                  <div className="card-wrapper">
                    <div className="card-header">
                      <h4>{store.storeRegion}</h4>
                    </div>
                    <div className="card-image">
                      {store.storeImg ? <img
                        src={
                          imagePrefix +
                          store.storeImgPath + store.storeImg[0]
                        }
                      /> : <></>}
                      
                    </div>
                    <div className="card-data">
                      <h5>{store.storeTitle}</h5>
                      <h5>{store.storeName}</h5>
                    </div>
                    <div
                      className="card-link"
                      onClick={() => {
                        this.selectStore(
                          this.state.storeData[key],
                          this.state.storeData,
                          this.state.citySelected,
                          this.state.regions
                        );
                      }}
                    >
                      Vist our {store.storeRegion} centre
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
